import React from 'react';
import { Wordmark } from './Wordmark';
export function Hero() {
  return <section className="min-h-[85vh] flex flex-col items-center justify-center px-6 md:px-12 lg:px-24 max-w-7xl mx-auto pt-6 pb-28 text-center" data-id="element-37" data-mp="ejwknco0ih7u">
      {/* The wordmark — the door to the house. This page IS Reserve. */}
      <Wordmark size="xl" submark="Reserve" align="center" data-id="element-38" data-mp="4m8mecr76rkx" />

      {/* The primary positioning line, set upright for a more tailored register */}
      <p className="font-serif font-light text-ink/90 text-2xl md:text-3xl lg:text-4xl leading-snug mt-12 md:mt-16 max-w-3xl" data-id="element-39" data-mp="128pijeo72z53">
        Your Chief Executive of Health.
      </p>

      {/* Sub-tagline — the protective frame */}
      <p className="font-serif font-light text-ink/70 text-lg md:text-xl lg:text-2xl leading-relaxed mt-6 max-w-2xl" data-id="element-40" data-mp="nc88qrvnlskn">
        Those who have built everything deserve a partner who protects it all.
      </p>

      {/* The short brass rule — the deck's visual punctuation */}
      <div className="mt-12 mb-12 h-px w-20 bg-brass" aria-hidden="true" data-id="element-41" data-mp="3814brpijjyoc" />

      {/* Supporting line — quiet, declarative, closes the arrival */}
      <p className="font-sans text-base md:text-lg font-light text-ink/70 max-w-2xl leading-relaxed" data-id="element-42" data-mp="3o859n6oa5t2g">
        A private house built around people who run everything except this.
      </p>
    </section>;
}